import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'

const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagProductsByType",
    title: "Auto Tag Products By Type",
    description: "Automatically tag products using the \"Type\" field.",
    example: "If a product has type Clothes, a tag Clothes will be added to the product.",
    additional: [
        "You can specify prefix, capitalization, and spacing settings for tags",
    ],
    legacy: false,
    inProgress: false,
    previewType: "ProductTags",
    dataPermissions: ["products"],
    allowPreview: true,
    tags: ["Products", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagProductsByType",
                prefix: null,
                casingTransformation: "KeepOriginal",
                spacesTransformation: "KeepSpaces",
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {
                    if (rule.settings.casingTransformation == null || rule.settings.casingTransformation === "") {
                        errors["casingTransformation"] = "Casing value is required";
                    }

                    if (rule.settings.spacesTransformation == null || rule.settings.spacesTransformation === "") {
                        errors["spacesTransformation"] = "Spaces value is required";
                    }
                }
            ], null);
    }
};

export default ruleDefinition;